export const getItemOrigin = () =>
  window.location.hostname.toLowerCase().indexOf('baby.zola.com') > -1
    ? 'BABY_REGISTRY'
    : 'WEDDINGS';
